import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { callApi, getCurSiteId } from '../lib/Common_funcs';
import {
  FiEdit3, FiEye, FiExternalLink, FiLayout,
  FiCheck, FiAlertTriangle, FiChevronLeft, FiChevronRight,
} from 'react-icons/fi';

const StSiteEditor = () => {
  const navigate = useNavigate();
  const [templates] = useState([]);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [activeSiteSource, setActiveSiteSource] = useState(null); // 'zip' | 'ai' | null
  const [currentSiteName, setCurrentSiteName] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingTemplate, setPendingTemplate] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const [moreItems, setMoreItems] = useState(false);
  const [lastTemplateId, setLastTemplateId] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [fetchTemplates, setFetchTemplates] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const templatesPerPage = 9;

  useEffect(() => {
    const currSiteName = localStorage.getItem('curSite');
    if (currSiteName) setCurrentSiteName(currSiteName);
  }, []);

  useEffect(() => {
    const fetchCurrentTemplate = async () => {
      setLoading3(true);
      try {
        const curSiteId = getCurSiteId();
        const response = await callApi('/sites/' + curSiteId, 'GET', {}, {});
        console.log("reponsesitedata", response)
        if (response.respBody) {
          const siteData = response.respBody;
          console.log("sitedata", siteData)
          if (siteData.siteSource && siteData.siteSource.startsWith('template-')) {
            const templateId = siteData.siteSource.replace('template-', '');
            console.log("templateId", templateId);
            const domain = process.env.REACT_APP_HOST_DOMAIN;
            setCurrentTemplate({
              templateId: templateId,
              templateName: templateId.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
              templateScreenShot: `https://www.turbosteed-staging.com/templates/${templateId}/screenshot.png`,
              templatePreviewLink: `https://www.turbosteed-staging.com/templates/${templateId}/index.html`,
              fromExisting: true,
            });
          } else if (siteData.siteSource === 'zip') {
            setActiveSiteSource('zip');
          }
        }
      } catch (err) {
        console.error('Error fetching current template:', err);
      }finally{
        setLoading3(false);
      }
    };

    // Only fetch current template after templates are loaded
    // if (templates.length > 0) {
      fetchCurrentTemplate();
    // }else{
      console.log("Templates not loaded yet", templates.length);
    // }
  }, [currentSiteName]);

  useEffect(() => {
    const fetchTemplates = async () => {
      moreItems ? setLoading2(true) : setLoading(true);
      try {
        let apiBaseURL = moreItems? `https://${process.env.REACT_APP_HOST_URL}/templates?lastTemplate=${lastTemplateId}` : `https://${process.env.REACT_APP_HOST_URL}/templates`;
        const response = await fetch(apiBaseURL);
        const data = await response.json();
        console.log('Fetched templates:', data);
        // moreItems? templates.push(...data.templates) : setTemplates(data.templates) ;
        templates.push(...data.templates)
        setMoreItems(data.moreItems || false);
        setLastTemplateId(data?.templates?.[data.templates.length - 1]?.templateId || null);
        setTotalPages((prevState) => prevState + 1);
      } catch (err) {
        console.error('Error fetching templates:', err);
      } finally {
        moreItems ? setLoading2(false) : setLoading(false);
      }
    };

    fetchTemplates();
  }, [fetchTemplates]);

  useEffect(() => {
    if (showConfirmModal) {
      // Store current scroll position
      const scrollY = window.scrollY;

      // Prevent body scroll
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      // Restore body scroll
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';

      // Restore scroll position
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    // Cleanup function
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    };
  }, [showConfirmModal]);

  // Reset to first page when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedCategory]);

  const handleEditTemplate = (template) => {
    const hasExistingTemplate = currentTemplate !== null;
    const isDifferentTemplate = hasExistingTemplate &&
      currentTemplate.templateId !== template.templateId;

    if (isDifferentTemplate) {
      setPendingTemplate(template);
      setShowConfirmModal(true);
    } else {
      proceedToEditTemplate(template);
    }
  };

  const proceedToEditTemplate = (template) => {
    navigate(`/edit-template/${template.templateId}`);
  };

  const handleConfirmSwitch = () => {
    if (pendingTemplate) {
      localStorage.removeItem('EditedDataJson');
      localStorage.removeItem('templateJSON');
      proceedToEditTemplate(pendingTemplate);
    }
    setShowConfirmModal(false);
    setPendingTemplate(null);
  };

  const handleCancelSwitch = () => {
    setShowConfirmModal(false);
    setPendingTemplate(null);
  };

  // Filter templates to exclude the current template
  // const availableTemplates = templates.filter(template =>
  //   !currentTemplate || currentTemplate.templateId !== template.templateId
  // );

  // const filteredTemplates = availableTemplates
  //   .filter(t => t.templateName.toLowerCase().includes(searchTerm.toLowerCase()));

  // Pagination calculations
  // const totalPages = Math.ceil(filteredTemplates.length / templatesPerPage);
  //  const totalPages = 3;
  const indexOfLastTemplate = currentPage * templatesPerPage;
  const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
  const currentTemplatesPage = templates.slice(indexOfFirstTemplate, indexOfLastTemplate);

  console.log("Current Templates Page: ", currentTemplatesPage);

  // Pagination handlers
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    const nextPage = currentPage + 1;
    const nextPageStart = currentPage * templatesPerPage;
    if (nextPageStart < templates.length) {
      setCurrentPage(nextPage);
    } else if (moreItems) {
      setCurrentPage(nextPage);
      setFetchTemplates(!fetchTemplates);
    }
  };


  const isNextDisabled = currentPage * templatesPerPage >= templates.length && !moreItems;

  if (loading) {
    return (
      <div className="app-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center' }}>
          <Spinner animation="border" style={{ width: '2rem', height: '2rem', color: 'var(--accent-primary)' }} />
          <div style={{ marginTop: '12px', fontSize: '13px', color: 'var(--text-tertiary)' }}>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-content animate-in">

      {/* Page header */}
      <div className="dashboard-header">
        <h1 className="dashboard-title">Site Editor</h1>
        <p className="dashboard-subtitle">Manage and customize your website template</p>
      </div>

      {/* Active Template */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--success)' }} />
          <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Active Template
          </span>
        </div>

        {loading3 ? (
          <div className="bento-card" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Spinner animation="border" style={{ width: '16px', height: '16px', borderWidth: '2px', color: 'var(--accent-primary)' }} />
            <span style={{ fontSize: '13px', color: 'var(--text-tertiary)' }}>Loading active template...</span>
          </div>
        ) : currentTemplate ? (
          <div className="bento-card" style={{ padding: 0, overflow: 'hidden', maxWidth: '280px' }}>
            <div style={{
              height: '180px', position: 'relative',
              background: `url(${currentTemplate.templateScreenShot}) center/cover no-repeat`,
              borderBottom: '1px solid var(--border-color)', backgroundColor: 'var(--bg-tertiary)',
            }}>
              <div style={{
                position: 'absolute', top: '10px', right: '10px',
                display: 'flex', alignItems: 'center', gap: '4px',
                padding: '3px 10px', borderRadius: '100px',
                background: 'var(--success)', color: 'white',
                fontSize: '11px', fontWeight: 500,
              }}>
                <FiCheck size={11} /> Active
              </div>
            </div>
            <div style={{ padding: '16px' }}>
              <h3 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px', color: 'var(--text-primary)' }}>
                {currentTemplate.templateName}
              </h3>
              <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', margin: '0 0 14px' }}>
                Currently active on your website
              </p>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => handleEditTemplate(currentTemplate)}
                  style={{
                    flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                    padding: '8px 12px', background: 'var(--accent-gradient)', color: 'white',
                    border: 'none', borderRadius: 'var(--radius-md)', fontSize: '12px',
                    fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
                  }}
                >
                  <FiEdit3 size={13} /> Continue Editing
                </button>
                <a
                  href={currentTemplate.templatePreviewLink} target="_blank" rel="noreferrer"
                  title="Preview template"
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    width: '36px', height: '36px', flexShrink: 0,
                    background: 'transparent', border: '1px solid var(--border-color)',
                    borderRadius: 'var(--radius-md)', color: 'var(--text-secondary)',
                    textDecoration: 'none',
                  }}
                >
                  <FiEye size={14} />
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="bento-card" style={{ textAlign: 'center', padding: '32px' }}>
            <FiLayout size={36} style={{ marginBottom: '12px', opacity: 0.3, color: 'var(--text-tertiary)' }} />
            <p style={{ fontSize: '13px', margin: 0, color: 'var(--text-tertiary)' }}>
              {activeSiteSource === 'zip'
                ? 'Your site uses a custom ZIP upload. Pick a template below to switch.'
                : 'No active template. Pick one from the gallery below.'}
            </p>
          </div>
        )}
      </div>

      {/* Template Gallery */}
      <div>
        <div style={{ marginBottom: '20px' }}>
          <h2 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '2px', color: 'var(--text-primary)' }}>
            Template Gallery
          </h2>
          <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', margin: 0 }}>
            Professional templates ready to customize
          </p>
        </div>

        {loading2 ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 0' }}>
            <Spinner animation="border" style={{ width: '1.5rem', height: '1.5rem', color: 'var(--accent-primary)' }} />
          </div>
        ) : currentTemplatesPage.length > 0 ? (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
              {currentTemplatesPage.map((template) => (
                <div key={template.templateId} className="bento-card" style={{ padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                  <div style={{
                    height: '180px', position: 'relative',
                    background: `url(${template.templateScreenShot}) center/cover no-repeat`,
                    borderBottom: '1px solid var(--border-color)',
                    backgroundColor: 'var(--bg-tertiary)',
                  }}>
                    {currentTemplate?.templateId === template.templateId && (
                      <div style={{
                        position: 'absolute', top: '10px', right: '10px',
                        display: 'flex', alignItems: 'center', gap: '4px',
                        padding: '3px 10px', borderRadius: '100px',
                        background: 'var(--success)', color: 'white',
                        fontSize: '11px', fontWeight: 500,
                      }}>
                        <FiCheck size={11} /> Active
                      </div>
                    )}
                  </div>
                  <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <h3 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px', color: 'var(--text-primary)' }}>
                      {template.templateName}
                    </h3>
                    <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', margin: '0 0 14px', flexGrow: 1 }}>
                      {template.templateDesc}
                    </p>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        onClick={() => handleEditTemplate(template)}
                        style={{
                          flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                          padding: '8px 12px', background: 'var(--accent-gradient)', color: 'white',
                          border: 'none', borderRadius: 'var(--radius-md)', fontSize: '12px',
                          fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
                        }}
                      >
                        <FiEdit3 size={13} />
                        {template?.templateId === currentTemplate?.templateId ? 'Continue Editing' : 'Start Editing'}
                      </button>
                      <a
                        href={template.templatePreviewLink} target="_blank" rel="noreferrer"
                        title="Preview template"
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          width: '36px', height: '36px', flexShrink: 0,
                          background: 'transparent', border: '1px solid var(--border-color)',
                          borderRadius: 'var(--radius-md)', color: 'var(--text-secondary)',
                          textDecoration: 'none',
                        }}
                      >
                        <FiEye size={14} />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '28px' }}>
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                style={{
                  display: 'flex', alignItems: 'center', gap: '4px',
                  padding: '7px 14px', background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)',
                  fontSize: '13px', fontWeight: 500, fontFamily: 'inherit',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  color: currentPage === 1 ? 'var(--text-tertiary)' : 'var(--text-primary)',
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <FiChevronLeft size={14} /> Prev
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  style={{
                    width: '36px', height: '36px', border: '1px solid var(--border-color)',
                    borderRadius: 'var(--radius-md)', fontSize: '13px', fontWeight: 500,
                    fontFamily: 'inherit', cursor: 'pointer',
                    background: page === currentPage ? 'var(--accent-primary)' : 'var(--bg-secondary)',
                    color: page === currentPage ? 'white' : 'var(--text-primary)',
                  }}
                >
                  {page}
                </button>
              ))}
              <button
                onClick={handleNextPage}
                disabled={isNextDisabled}
                style={{
                  display: 'flex', alignItems: 'center', gap: '4px',
                  padding: '7px 14px', background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)',
                  fontSize: '13px', fontWeight: 500, fontFamily: 'inherit',
                  cursor: isNextDisabled ? 'not-allowed' : 'pointer',
                  color: isNextDisabled ? 'var(--text-tertiary)' : 'var(--text-primary)',
                  opacity: isNextDisabled ? 0.5 : 1,
                }}
              >
                Next <FiChevronRight size={14} />
              </button>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--text-tertiary)' }}>
            <FiLayout size={36} style={{ marginBottom: '12px', opacity: 0.3 }} />
            <p style={{ fontSize: '14px', fontWeight: 500, marginBottom: '4px', color: 'var(--text-primary)' }}>
              No Templates Found
            </p>
            <p style={{ fontSize: '13px', margin: 0 }}>Check back later for available templates</p>
          </div>
        )}
      </div>

      {/* Confirm Switch Modal */}
      <Modal show={showConfirmModal} onHide={handleCancelSwitch} centered backdrop="static" keyboard={false}>
        <Modal.Header closeButton style={{ borderBottom: '1px solid var(--border-color)' }}>
          <Modal.Title style={{ fontSize: '15px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '32px', height: '32px', borderRadius: 'var(--radius-md)',
              background: 'var(--warning-soft)', display: 'flex', alignItems: 'center',
              justifyContent: 'center', color: 'var(--warning)', flexShrink: 0,
            }}>
              <FiAlertTriangle size={16} />
            </div>
            Switch Template?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '14px' }}>
          <div style={{
            background: 'var(--warning-soft)', borderRadius: 'var(--radius-md)',
            padding: '14px 16px', lineHeight: 1.6,
          }}>
            Switching to <strong>{pendingTemplate?.templateName}</strong> will permanently delete your
            current template configuration. This cannot be undone.
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid var(--border-color)', gap: '8px' }}>
          <Button variant="secondary" onClick={handleCancelSwitch}>Cancel</Button>
          <Button variant="warning" onClick={handleConfirmSwitch}>
            <FiCheck size={13} className="me-1" /> Switch Template
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default StSiteEditor;
